import usStateAbbrev from "./usStateAbbrev";

const stateNamesByLength = Object.keys(usStateAbbrev).sort((a, b) => b.length - a.length);

interface IAddressParts {
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

interface IFormatAddressOptions {
    includeZip?: boolean;
}

export function shortenAddress(input: string | null | undefined, options: IFormatAddressOptions = {}): string {
    if (!input) return "";

    let result = input.trim().replace(/,\s*(United States|USA|US)\s*$/i, "");

    for (const stateName of stateNamesByLength) {
        const escaped = stateName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const re = new RegExp(`(,\\s*)${escaped}\\b(?=\\s+\\d{5}|\\s*$)`, "g");
        result = result.replace(re, `$1${usStateAbbrev[stateName]}`);
    }

    if (!options.includeZip) {
        result = result.replace(/\s+\d{5}(?:-\d{4})?(?=\s*,|\s*$)/g, "");
    }

    return result.replace(/,\s*$/, "").replace(/\s+/g, " ").trim();
}

export function formatAddress(parts: IAddressParts | null | undefined, options: IFormatAddressOptions = {}): string {
    if (!parts) return "";

    const { address, city, state, zip } = parts;

    if (address?.includes(",")) return shortenAddress(address, options);

    const stateAbbrev = state ? (usStateAbbrev[state] ?? state) : "";
    const cityState = [city, stateAbbrev].filter(s => s && s.trim()).join(", ");
    const trailing = options.includeZip && zip ? `${cityState} ${zip}`.trim() : cityState;

    return [address, trailing].filter(s => s && s.trim()).join(", ");
}
